<script>

import SliderPhoto from '@/components/slider-photo';
import catalog from '@/mixins/catalog';


export default {name:"one-project",

                        props: [
                                'item',
                                'path',
                                'teaser',
                                'isPlaying'
                            ],
                        components:{"slider-photo": SliderPhoto},
                        mixins:[catalog],
                        data:function(){

                            return {
                                        
                                                            
                                    }
						
                        },
                        mounted() {
                            
                           

                        },

                        created: function(){

           
                            //console.log(this.maxHeight);

                        }, 

                        computed: {
							
							
                        },
						methods:{

                            getPath(img)
                            {
                                return this.path+"/images/"+img;
                            },

                            // ипотечный платёж для карточки проекта: расчёт
                            // при параметрах тизера (mortgage_config.php → teaser:
                            // 6% / взнос 20,1% / 30 лет), как в hero карточки дома
                            mortgagePayment(item)
                            {
                                const price = parseInt(item.PROPS.PRICE[0].VALUE);
                                if (!price) {
                                    return null;
                                }
                                const t = this.teaser || {rate: 6, downPayment: 0.201, termMonths: 360};
                                const sum = price - price * t.downPayment;
                                const i = Number(t.rate) / 100 / 12;
                                const n = t.termMonths;
                                if (!i) {
                                    return Math.round(sum / n);
                                }
                                const k = Math.pow(1 + i, n);
                                return Math.round(sum * i * k / (k - 1));
                            },

                            mortgageRate()
                            {
                                const t = this.teaser || {rate: 6};
                                const v = Number(t.rate);
                                return (Number.isInteger(v) ? String(v) : String(v).replace('.', ','));
                            }

						}

					}

</script>

<template>
    
    <div class="slider-built-cottages__item">
    <a :href="item.DETAIL_PAGE_URL" class="">
                                    <div class="cottages__images-img">
                                        
                                            <slider-photo :item="item" :max-height="174" :is-playing="isPlaying"></slider-photo>
                                       
                                           
                                       
                                    </div>
                                    <div class="built-cottage__content-wrapper">
                                        <div class="built-cottage__content">
                                            <p class="built-cottage__content-title">
                                                <a :href="item.DETAIL_PAGE_URL">{{item.NAME}}</a>
                                            </p>
                                            <p class="projects-home__note">
                                                Построим на выбраном вами участке
                                            </p>
                                            <p class="built-cottage__price" v-if="checkPrice(item)">
                                                от {{ mortgagePayment(item) | currency }}<span class="built-cottage__price-unit">/мес</span>
                                            </p>
                                            <p class="built-cottage__credit-note" v-if="checkPrice(item)">
                                                ипотека от {{ mortgageRate() }}% · платёж ориентировочный, не является офертой
                                            </p>
                                        </div>
                                        <div class="built-cottage__details">
                                            <div class="built-cottage__detail">
                                                <p class="built-cottage__details-name">Спальни:</p>
                                                <div class="built-cottage__details-count">{{item.PROPS.ROOMS[0].VALUE}}</div>
                                            </div>
                                            <div class="built-cottage__detail">
                                                <p class="built-cottage__details-name">Санузлов:</p>
                                                <div class="built-cottage__details-count">{{item.PROPS.BATHROOMS[0].VALUE}}</div>
                                            </div>
                                            <div class="built-cottage__detail">
                                                <p class="built-cottage__details-name">Этажей:</p>
                                                <div class="built-cottage__details-count">{{item.PROPS.FLOORS[0].VALUE}}</div>
                                            </div>
                                            <div class="built-cottage__detail">
                                                <p class="built-cottage__details-name">Площадь:</p>
                                                <div class="built-cottage__details-count">{{item.PROPS.M2[0].VALUE}} м²</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="built-cottage__info">
                                        <p class="project-check">Проект дома</p>
                                        <div class="house-icons">
                                            <button class="house-icon__btn">
                                                <img class="house-icon__img house-icon__img-add house-icon-compare-cor"
                                                :src="getPath('icone-favourite-add.svg')" alt="Icon">
                                            </button>
                                            <button class="house-icon__btn">
                                                <img class="house-icon__img" :src="getPath('icon-heart.svg')" alt="Icon">
                                            </button>
                                        </div>
                                    </div>
    </a>
    </div>
    
</template>  


